import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { FormGrid, FlexWrapper, FormInput } from "components/molecules";
import Dropdown from "components/molecules/dropdown/Dropdown";
import { Input } from "components/atoms";
import { INotificationSettingsForm } from "services/configuration/notifications/types";

const NotificationContent = () => {
  const { values, status, setFieldValue } =
    useFormikContext<INotificationSettingsForm>();
  const { t } = useTranslation();

  const mockedNotifications = values.mockedNotifications || {};

  const handleSelectAll = (domain: string, isSelected: boolean) => {
    const updatedNotifications = {
      ...mockedNotifications,
      [domain]: {
        ...mockedNotifications[domain],
        notifications: mockedNotifications[domain].notifications.map(
          (notification) => ({
            ...notification,
            isSelected,
          })
        ),
      },
    };

    setFieldValue("mockedNotifications", updatedNotifications);
  };

  const handleNotificationChange = (
    domain: string,
    index: number,
    field: string,
    value: boolean
  ) => {
    const updatedNotifications = {
      ...mockedNotifications,
      [domain]: {
        ...mockedNotifications[domain],
        notifications: mockedNotifications[domain].notifications.map(
          (notification, idx) =>
            idx === index ? { ...notification, [field]: value } : notification
        ),
      },
    };

    setFieldValue("mockedNotifications", updatedNotifications);
  };

  const sortedDomains = Object.keys(mockedNotifications).sort((a, b) => {
    if (a === "-1") return 1;
    if (b === "-1") return -1;
    const aTranslated = t(`notifications.domains.${a}`);
    const bTranslated = t(`notifications.domains.${b}`);
    return aTranslated.localeCompare(bTranslated);
  });

  const getSortedNotifications = (domain: string) => {
    return [...mockedNotifications[domain].notifications].sort((a, b) => {
      const aTranslated = t(`notifications.${a.id}`);
      const bTranslated = t(`notifications.${b.id}`);
      return aTranslated.localeCompare(bTranslated);
    });
  };

  return (
    <FlexWrapper>
      {sortedDomains.map((domain) => {
        if (domain === "-1") {
          return null;
        }
        return (
          <Dropdown
            key={domain}
            title={t(`notifications.domains.${domain}`)}
            extraElement={
              <Input.Switch
                label=""
                onChange={(checked) => handleSelectAll(domain, checked)}
                checked={mockedNotifications[domain].notifications.some(
                  (notification) => notification.isSelected
                )}
                className={`${
                  status?.displayMode
                    ? "pointer-events-none"
                    : "pointer-events-auto"
                }`}
              />
            }
          >
            <FormGrid>
              {getSortedNotifications(domain).map(
                (notification, index) => (
                  <div className="flex flex-col" key={index}>
                    <FormInput.Switch
                      name={`mockedNotifications.${domain}.notifications.${index}.isSelected`}
                      label={t(`notifications.${notification.id}`)}
                      checked={notification.isSelected}
                      onChange={(checked: boolean) =>
                        handleNotificationChange(
                          domain,
                          index,
                          "isSelected",
                          checked
                        )
                      }
                      className={`${
                        status?.displayMode
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      }`}
                    />
                    <FormInput.Switch
                      name={`mockedNotifications.${domain}.notifications.${index}.sendEmail`}
                      label={t(`notifications.sendEmail`)}
                      checked={notification.sendEmail}
                      onChange={(checked: boolean) =>
                        handleNotificationChange(
                          domain,
                          index,
                          "sendEmail",
                          checked
                        )
                      }
                      disabled={!notification.isSelected}
                      className={`${
                        status?.displayMode
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      }`}
                    />
                  </div>
                )
              )}
            </FormGrid>
          </Dropdown>
        );
      })}
      <div className="mb-8" />
    </FlexWrapper>
  );
};

export default NotificationContent;
